import classNames from "classnames";
import React from "react";
import { WordleCharacterResult } from "./types";

export declare namespace WordleCharacter {
  export interface Props {
    char: string | undefined;
    result?: WordleCharacterResult;
    colorBorderOnly: boolean;
  }
}

export const WordleCharacter = React.memo(function WordleCharacterImpl({
  char,
  result,
  colorBorderOnly,
}: WordleCharacter.Props) {
  return (
    <div
      className={classNames(
        "h-14 uppercase flex justify-center items-center font-uppercase text-3xl font-bold font-mono min-w-0 basis-14 select-none",
        "border",
        char != null && {
          "border-gray-700": result == "?" || result == null,
          "border-gray-800": result === "B",
          "border-char-green/50": result === "G",
          "border-char-yellow/50": result === "Y",
          "border-char-red/70": result === "R",
        },
        colorBorderOnly
          ? [
              "border-[2px]",
              {
                "bg-[#1a1a1a] text-gray-300": result === "B",
                "bg-char-green/5 text-char-green": result === "G",
                "bg-char-yellow/5 text-char-yellow": result === "Y",
              },
            ]
          : [
              {
                "bg-char-green": result === "G",
                "bg-char-yellow": result === "Y",
                "bg-char-red": result === "R",
                "bg-char-gray": result === "B",
                "border-transparent border-b-gray-700": char == null,
              },
            ]
      )}
    >
      {char}
    </div>
  );
});
